/** The pubkey of Bugle.News (the poll organizer) */
export const ORGANIZER_PUBKEY = 'a6a22d58db6709e81c5717667dbee2ddbac22448575dabf92f4b30c6ee1129f1';

/** Round 1 announcement event ID */
export const ROUND1_EVENT_ID = 'b648db6243ffe26182e76f61d0f66f262da40ec6ff44d4104f56b0512747ad0a';

/** Round 2 announcement event ID */
export const ROUND2_EVENT_ID = 'e2438594decf4af96ffa8b22d411673dea41066d28b53c9b2e6ba38fc178a5d1';

/** The bracket image URL */
export const BRACKET_IMAGE_URL = 'https://blossom.primal.net/0ac2dd3cac66f9e18b5c3e726d05e2959efd63f2a5bdbf139399964e83fa0f14.jpg';

/** Round 2 bracket image */
export const ROUND2_IMAGE_URL = 'https://blossom.primal.net/1e61e71de8a86e36c9a83f9cac1f992173febb596268dc1dedcb16b975bafd17.jpg';

/** Ditto link to the original thread */
export const DITTO_THREAD_URL = 'https://ditto.pub/nevent1qgs2dg3dtrdkwz0gr3t3wenahm3dmwkzy3y9whdtlyh5kvxxacgjnugqyzmy3kmzg0l7ycvzuahkr58kdunzmfqwcml5f4qsfattq5f8g7ks52s92uw';

/** Nostr 101 link */
export const NOSTR_101_URL = 'https://about.ditto.pub/nostr-101';

/** Relays to query for polls */
export const POLL_RELAYS = [
  'wss://relay.damus.io',
  'wss://relay.ditto.pub',
  'wss://relay.primal.net',
  'wss://nos.lol',
];

/** Kind 6969 is Primal's zap poll format */
export const POLL_KIND = 6969;
